module.exports = __webpack_public_path__ + "img/fashion.ad985e1e.svg";